import SalesDealsApi from 'api/admins/sales-deals-api'
import { RedirectButton, TitlePage } from 'components/atoms'
import { ALERT_TYPES } from 'constants/alert-constants'
import { SalesDealsCreateForm } from 'domains/sales/deals/forms'
import PropTypes from 'prop-types'
import { Card } from 'reactstrap'

const propTypes = {
  pageUtils: PropTypes.shape({
    setAlertMsg    : PropTypes.func,
    setApiErrorMsg : PropTypes.func
  })
}

const buildFullName = (firstName, lastName) => {
  const first = (firstName || '').trim()
  const last  = (lastName || '').trim()
  return [ first, last ].filter(Boolean).join(' ').trim()
}

const SalesDealsCreatePage = ({ pageUtils }) => {

  const handleSubmitForm = async (values, formikBag) => {
    // remove client-only fields
    const {
      product_ids,                // admin UI display only
      product_search,             // admin UI search only
      hide_existing_user_detail,  // UI gate only

      // UI-only split name fields (we submit combined "name")
      first_name,
      last_name,

      ...payload
    } = values || {}

    // Always submit full name as "name" to backend
    const fullName = buildFullName(first_name, last_name)
    if(fullName){
      payload.name = fullName
    }

    // IMPORTANT: keep API contract stable
    // Only send expected keys inside items[]
    payload.items = (payload.items || []).map((it) => ({
      product_id: it.product_id,
      selling_price: it.selling_price, // Final Price (nego)
      authenticator: it.authenticator,
      authenticity_check_note: it.authenticity_check_note,
      include_authenticity_check: it.include_authenticity_check,
      note: it.note,
    }))

    await SalesDealsApi.create(payload)
      .then((response) => {
        const deal = response.data.data
        const msg = (
          <>
            { 'Deals berhasil dibuat' } &nbsp;
            <RedirectButton
              text={ 'Lihat Detail Deals' }
              path={ `/app/sales/deals/${deal.id}` }
            />
          </>
        )
        pageUtils.setAlertMsg(msg, ALERT_TYPES.SUCCESS)
        formikBag.resetForm()
      })
      .catch((error) => {
        formikBag.setErrors(error.response.data.messages)
        pageUtils.setApiErrorMsg(error.response.data)
      })
  }

  const checkUserEmailIsUnique = async (email) => {
    await SalesDealsApi.isUserEmailUnique({email})
      .then((response) => {
        const isUnique = response.data.is_unique
        if(!isUnique){
          const msg = 'Email sudah terdaftar'
          pageUtils.setAlertMsg(msg, ALERT_TYPES.DANGER)
        }
      })
      .catch((error) => {
        pageUtils.setApiErrorMsg(error.response.data)
      })
  }

  const checkUserPhoneIsUnique = async (phone) => {
    await SalesDealsApi.isUserPhoneUnique({phone})
      .then((response) => {
        const isUnique = response.data.is_unique
        if(!isUnique){
          const msg = 'Phone sudah terdaftar'
          pageUtils.setAlertMsg(msg, ALERT_TYPES.DANGER)
        }
      })
      .catch((error) => {
        pageUtils.setApiErrorMsg(error.response.data)
      })
  }

  return (
    <>
      <TitlePage mainTitle={ 'Buat Deals' } />

      <Card body>
        <SalesDealsCreateForm
          onSubmitForm={ handleSubmitForm }
          checkUserEmailIsUnique={ checkUserEmailIsUnique }
          checkUserPhoneIsUnique={ checkUserPhoneIsUnique }
        />
      </Card>
    </>
  )

}

SalesDealsCreatePage.propTypes = propTypes

export default SalesDealsCreatePage
